module.exports = __webpack_public_path__ + "static/media/coming-sson-taotao.430f7c96.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/index/coming-sson-taotao.png
// module id = 644
// module chunks = 1